import React, { useState } from "react";
import axios from "axios";
import CurrentTimeDate from "./CurrentTimeDate";
import UnitLinks from "./unitLinks";
import WeatherIcon from "./WeatherIcon";
import Forecasts from "./Forecasts";
//<Forecasts lat={weather.lat} lon={weather.lon} />

export default function CurrentDetails() {
  const [loaded, setLoaded] = useState(false);
  const [city, setCity] = useState(null);
  const [weather, setWeather] = useState({});

  const form = (
    <form id="search-city-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label>Search City</label>
        <input
          type="text"
          className="form-control"
          id="search-city"
          placeholder="Enter a city"
          onChange={updateCity}
        />
      </div>
      <button type="submit" className="btn btn-primary" id="search-city-button">
        Submit
      </button>
      <span id="button-span">
        <button
          type="submit"
          className="btn btn-primary"
          id="search-current-location-button"
          onClick={searchCurrentLocation}
        >
          Search current location
        </button>
      </span>
    </form>
  );

  function searchCurrentLocation(event) {
    event.preventDefault();
    navigator.geolocation.getCurrentPosition(LocationCoords);
    function LocationCoords(position) {
      let apiKey = "f85062d84430cd35a6b8db439bd6c8f6";
      let weatherApiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${position.coords.latitude}&lon=${position.coords.longitude}&appid=${apiKey}&units=metric`;
      axios.get(weatherApiUrl).then(showWeather);
    }
  }

  function searchCurrentLocationOnLoad() {
    navigator.geolocation.getCurrentPosition(LocationCoords);
    function LocationCoords(position) {
      let apiKey = "f85062d84430cd35a6b8db439bd6c8f6";
      let weatherApiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${position.coords.latitude}&lon=${position.coords.longitude}&appid=${apiKey}&units=metric`;
      axios.get(weatherApiUrl).then(showWeather);
    }
  }

  function updateCity(event) {
    setCity(event.target.value);
  }

  function handleSubmit(event) {
    event.preventDefault();
    let apiKey = "f85062d84430cd35a6b8db439bd6c8f6";
    let url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(url).then(showWeather);
  }

  function showWeather(response) {
    setLoaded(true);
    setWeather({
      searchedCity: response.data.name,
      celsiusTemperature: Math.round(response.data.main.temp),
      humidity: response.data.main.humidity,
      windspeed: Math.round(response.data.wind.speed),
      description: response.data.weather[0].main,
      lat: response.data.coord.lat,
      lon: response.data.coord.lon,
      icon: response.data.weather[0].icon,
    });
  }

  if (loaded) {
    return (
      <div>
        <div className="container" id="search-form-container">
          <div className="row">
            <div className="col-12 buttons">{form}</div>
          </div>
          <div id="current-details">
            <div className="container">
              <div className="row">
                <CurrentTimeDate city={weather.searchedCity} />
                <div className="col-6">
                  <div>
                    <div className="CurrentWeather">
                      Weather: {weather.description}{" "}
                      <WeatherIcon
                        code={weather.icon}
                        alt={weather.description}
                      />
                    </div>
                    <UnitLinks celsius={weather.celsiusTemperature} />
                    <div className="CurrentWeather">
                      Current humidity: {weather.humidity}%
                    </div>
                    <div className="CurrentWeather">
                      Current windspeed: {weather.windspeed} km/h
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Forecasts lat={weather.lat} lon={weather.lon} />
        </div>
      </div>
    );
  } else {
    searchCurrentLocationOnLoad();
    return (
      <div>
        <div className="container" id="search-form-container">
          <div className="row">
            <div className="col-12 buttons">{form}</div>
          </div>
          <div id="current-details">
            <div className="container">
              <div className="row">
                <CurrentTimeDate city="" />
                <div className="col-6">
                  <div>
                    <div className="CurrentWeather">
                      Weather:
                      <WeatherIcon code="" alt="Clear" />
                    </div>
                    <UnitLinks celsius="" />
                    <div className="CurrentWeather">Current humidity: %</div>
                    <div className="CurrentWeather">
                      Current windspeed: km/h
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
